import {query} from "@solidjs/router";
import {getSession, useSession} from "vinxi/http";
import api from "~/api/api";
import {AuthResponse, UserResponse, VerifyRequest} from "@tag-tails/types"

export async function signOut() {
    "use server";
    try {
        const session = await useSession({password: process.env.SESSION_SECRET!});
        const token = session.data.token;
        if (!token) return;
        await session.update({token: null});
        await api.delete(`/sessions/token/${token}`);
    } catch (e) {
        throw new Error("Failed to sign out");
    }
}

export async function submitCode(dto: VerifyRequest): Promise<AuthResponse | null> {
    "use server";
    return await api.post("/auth/signin", dto) as AuthResponse;
}

export const getUser = query(async (): Promise<UserResponse | null> => {
    "use server";
    try {
        const session = await getSession({password: process.env.SESSION_SECRET!});
        const token = session.data.token;
        if (!token) return null;
        const response = await api.get<UserResponse>(`/users/token/${token}`);
        return response.data;
    } catch (e) {
        return null;
    }
}, "user");
